module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_5_2.1ad7f332.png";